import React, { useEffect, useState } from "react";
import { useCart } from "../../context/CartContext";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import "./MyCart.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FaTrashAlt } from "react-icons/fa";
import { setDoc, collection, addDoc, Timestamp } from "firebase/firestore";
import emailjs from "@emailjs/browser";

const db = getFirestore();

const MyCart = () => {
  const { cart, updateCartCount } = useCart(); // Coșul conține doar ID-urile produselor
  const [cartDetails, setCartDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quantities, setQuantities] = useState({}); // Obiect pentru cantități
  const [deliveryMethod, setDeliveryMethod] = useState(""); // Opțiunea de livrare
  const [personalData, setPersonalData] = useState({ name: "", surname: "" });
  const [address, setAddress] = useState({ street: "", number: "", city: "" });
  const [contact, setContact] = useState({ email: "", phone: "" });
  const [customerType, setCustomerType] = useState("fizica");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsGeneralAccepted, setTermsGeneralAccepted] = useState(false);
  const [paymentInfoAccepted, setPaymentInfoAccepted] = useState(false);
  const [formData, setFormData] = useState({
    businessName: "",
    cui: "",
    registrationNumber: "",
    fullAddress: "",
  });
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    const fetchCartDetails = async () => {
      const validCart = cart.filter(
        (id) => id !== undefined && id !== null && id !== ""
      );
      if (validCart.length === 0) {
        setLoading(false);
        return;
      }

      try {
        const promises = validCart.map(async (productId) => {
          const docRef = doc(db, "Products", productId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            return { id: productId, ...docSnap.data() };
          } else {
            console.warn(`Produsul cu ID-ul ${productId} nu a fost găsit.`);
            return null;
          }
        });

        const products = await Promise.all(promises);
        setCartDetails(products.filter((product) => product !== null));

        // Inițializează cantitățile produselor cu valoarea 1
        const initialQuantities = validCart.reduce((acc, id) => {
          acc[id] = 1; // Cantitatea implicită este 1
          return acc;
        }, {});
        setQuantities(initialQuantities);
      } catch (error) {
        console.error("Eroare la încărcarea produselor din coș:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCartDetails();
  }, [cart]);

  const handleQuantityChange = (id, delta) => {
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [id]: Math.max(prevQuantities[id] + delta, 1), // Previne cantitățile negative sau zero
    }));
  };

  const handleRemoveFromCart = (id) => {
    const updatedCart = cart.filter((productId) => productId !== id);
    updateCartCount(updatedCart); // Actualizează contextul cu coșul actualizat
    setCartDetails(cartDetails.filter((product) => product.id !== id)); // Actualizează vizual lista de produse
  };

  const handleDeliveryChange = (e) => {
    setDeliveryMethod(e.target.value);
  };

  const handleInputChange = (e, section) => {
    const { name, value } = e.target;
    if (section === "personalData") {
      setPersonalData((prevData) => ({ ...prevData, [name]: value }));
    } else if (section === "address") {
      setAddress((prevAddress) => ({ ...prevAddress, [name]: value }));
    } else if (section === "contact") {
      setContact((prevContact) => ({ ...prevContact, [name]: value }));
    }
  };

  // Calculează prețul total
  const calculateTotalPrice = () => {
    let total = 0;
    cartDetails.forEach((item) => {
      total += item.price * (quantities[item.id] || 1);
    });

    // Adaugă costul livrării dacă este selectat "curier"
    if (deliveryMethod === "curier") {
      total += 20; // Costul livrării
    }

    return total.toFixed(2);
  };

  if (loading) {
    return <div>Se încarcă produsele...</div>;
  }

  if (cartDetails.length === 0) {
    return <h1>Coșul este gol.</h1>;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleSubmit = async () => {
    // Verifică dacă toate câmpurile required sunt completate
    const isPersonalDataComplete = personalData.name && personalData.surname;
    const isAddressComplete =
      address.street && address.number && address.city && address.county;
    const isContactComplete = contact.email && contact.phone;
    const isDeliveryMethodSelected = deliveryMethod !== "";

    // Verifică câmpurile suplimentare dacă persoana juridică este selectată
    const isBusinessDataComplete =
      customerType === "juridica" &&
      document.querySelector('input[name="businessName"]').value &&
      document.querySelector('input[name="cui"]').value &&
      document.querySelector('input[name="registrationNumber"]').value &&
      document.querySelector('input[name="fullAddress"]').value;

    // Dacă toate sunt completate, afișează valorile
    if (
      isPersonalDataComplete &&
      isAddressComplete &&
      isContactComplete &&
      isDeliveryMethodSelected &&
      (customerType === "fizica" || isBusinessDataComplete) &&
      termsAccepted &&
      termsGeneralAccepted &&
      paymentInfoAccepted
    ) {
      const orderData = {
        businessDetails:
          customerType === "juridica"
            ? {
                businessName: formData.businessName,
                cui: formData.cui,
                registrationNumber: formData.registrationNumber,
                fullAddress: formData.fullAddress,
              }
            : null,
        customerData: personalData,
        delivery: deliveryMethod,
        contact: contact,
        address: address,
        customerType: customerType,
        items: cartDetails.map((item) => ({
          name: item.name,
          quantity: quantities[item.id],
        })),
        totalPrice: calculateTotalPrice(),
        status: "Așteptare plată",
        mentiuni: remarks,
        orderDate: Timestamp.now(),
      };

      // Trimite comanda la Firestore
      try {
        console.log(orderData);
        await addDoc(collection(db, "Orders"), orderData);
        alert("Comanda a fost trimisă cu succes!");
        const templateParams = {
          name: personalData.name,
          surname: personalData.surname,
          email: contact.email,
          phone: contact.phone,
        };

        emailjs
          .send(
            "service_29wmnpp", // Înlocuiește cu ID-ul serviciului tău
            "template_vjtx0om", // Înlocuiește cu ID-ul template-ului tău
            templateParams,
            "DPpnji40fMprI2p8J" // Înlocuiește cu cheia ta publică
          )
          .then(
            (response) => {
              console.log(
                "Email trimis cu succes!",
                response.status,
                response.text
              );
            },
            (error) => {
              console.error("Eroare la trimiterea emailului:", error);
            }
          );

        // Golește coșul
        updateCartCount([]);
        setCartDetails([]);
      } catch (error) {
        console.error("Eroare la trimiterea comenzii:", error);
        alert("A apărut o problemă. Încercați din nou.");
      }
    } else {
      alert("Vă rugăm completați toate câmpurile obligatorii.");
    }
  };

  return (
    <div className="my-cart-page">
      <h1>Coșul meu</h1>
      <div className="cart-container">
        <div className="cart-items">
          {cartDetails.map((item) => (
            <div key={item.id} className="cart-item">
              <img
                src={
                  item.imageURL && item.imageURL.length > 0
                    ? item.imageURL[0]
                    : "/placeholder-image.jpg"
                }
                alt={item.name || "Produs"}
                className="cart-item-image"
              />
              <div className="cart-item-details">
                <h3>{item.name || "Produs fără nume"}</h3>
                <p>{item.price ? `${item.price} RON` : "Preț indisponibil"}</p>
                <div className="quantity-controls">
                  <button
                    className="quantity-button"
                    onClick={() => handleQuantityChange(item.id, -1)}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </button>
                  <span className="quantity">{quantities[item.id]}</span>
                  <button
                    className="quantity-button"
                    onClick={() => handleQuantityChange(item.id, 1)}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </div>
              <button
                className="delete-button"
                onClick={() => handleRemoveFromCart(item.id)}
              >
                <FaTrashAlt style={{ fontSize: "24px" }} />
              </button>
            </div>
          ))}
          <div className="order-summary">
            <h2>Sumar comandă</h2>
            <div className="order-summary-details">
              <p>
                <strong>Preț total:</strong> {calculateTotalPrice()} RON
              </p>
            </div>
          </div>
        </div>

        {/* Sumarul comenzii */}

        {/* Secțiunea de Plata și livrare */}
        <div className="delivery-payment">
          <h2 className="delivery-payment-title">
            Informații cu privire la efectuarea plății:
          </h2>
          <div className="payment-info">
            <p>
              Înainte de a da comanda în lucru, va trebui efectuată plata
              integrală în contul:
              <p>
                <strong>Titular: FIRU ARTEI SRL</strong>
              </p>
              <p>
                <strong>IBAN: RO90BTRLRONCRT0CU5013301</strong>
              </p>
              <p>
                <strong>Banca: Banca Transilvania</strong>
              </p>
              Odată ce plata va fi confirmată, comanda va fi dată în lucru.
            </p>
          </div>
          <h2 className="delivery-payment-title">Metoda de livrare</h2>
          <p>
            Pentru a ajunge in posesia produselor din comanda, aveti la
            dispozitie următoarele opțiuni:
          </p>
          <div className="delivery-method">
            <label>
              <input
                type="radio"
                name="delivery"
                value="curier"
                onChange={handleDeliveryChange}
                checked={deliveryMethod === "curier"}
              />
              Livrare prin curier <span className="bold-text">(+20 RON)</span>
            </label>
            <label>
              <input
                type="radio"
                name="delivery"
                value="ridicare-personala"
                onChange={handleDeliveryChange}
                checked={deliveryMethod === "ridicare-personala"}
              />
              Ridicare personală
            </label>
          </div>
          <div className="google-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2733.532399992553!2d23.619363976251623!3d46.75440137112438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47490d7e53bc9263%3A0xcfaabd6f2612e9e6!2sViodin!5e0!3m2!1sen!2sro!4v1737216550490!5m2!1sen!2sro"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <hr className="divider" />

      {/* Container pentru checkout */}
      <h1 className="checkout-title">Finalizare comandă</h1>
      <div className="checkout-container">
        <div>
          {/* PF/PJ */}
          <div className="customer-type">
            <label>
              <input
                type="radio"
                name="customerType"
                value="fizica"
                checked={customerType === "fizica"}
                onChange={(e) => setCustomerType(e.target.value)}
              />
              Persoană fizică
            </label>
            <label>
              <input
                type="radio"
                name="customerType"
                value="juridica"
                checked={customerType === "juridica"}
                onChange={(e) => setCustomerType(e.target.value)}
              />
              Persoană juridică
            </label>
          </div>

          {customerType === "juridica" && (
            <div className="business-details*">
              <input
                type="text"
                name="businessName"
                className="checkout-input"
                placeholder="Nume firmă*"
                value={formData.businessName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="cui"
                className="checkout-input"
                placeholder="CUI/CIF*"
                value={formData.cui}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="registrationNumber"
                className="checkout-input"
                placeholder="Nr. reg. com*"
                value={formData.registrationNumber}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="fullAddress"
                className="checkout-input"
                placeholder="Adresă completă*"
                value={formData.fullAddress}
                onChange={handleChange}
                required
              />
            </div>
          )}
        </div>
        {/* Date personale */}
        <div className="personal-data">
          <h2>Date personale</h2>
          <input
            type="text"
            name="name"
            placeholder="Nume*"
            value={personalData.name}
            onChange={(e) => handleInputChange(e, "personalData")}
            required
            className="checkout-input"
          />
          <input
            type="text"
            name="surname"
            placeholder="Prenume*"
            value={personalData.surname}
            onChange={(e) => handleInputChange(e, "personalData")}
            required
            className="checkout-input"
          />
        </div>

        {/* Adresa */}
        <div className="address">
          <h2>Adresă</h2>
          <input
            type="text"
            name="street"
            placeholder="Strada*"
            value={address.street}
            onChange={(e) => handleInputChange(e, "address")}
            required
            className="checkout-input"
          />
          <input
            type="text"
            name="number"
            placeholder="Număr*"
            value={address.number}
            onChange={(e) => handleInputChange(e, "address")}
            required
            className="checkout-input"
          />
          <input
            type="text"
            name="apt"
            placeholder="Apartament"
            value={address.apt}
            onChange={(e) => handleInputChange(e, "address")}
            className="checkout-input"
          />
          <input
            type="text"
            name="city"
            placeholder="Localitate*"
            value={address.city}
            onChange={(e) => handleInputChange(e, "address")}
            required
            className="checkout-input"
          />
          <input
            type="text"
            name="county"
            placeholder="Județ/Sector*"
            value={address.county}
            onChange={(e) => handleInputChange(e, "address")}
            required
            className="checkout-input"
          />
          <input
            type="text"
            name="postCode"
            placeholder="Cod poștal"
            value={address.postCode}
            onChange={(e) => handleInputChange(e, "address")}
            className="checkout-input"
          />
        </div>

        {/* Date de contact */}
        <div className="contact-data">
          <h2>Date de contact</h2>
          <input
            type="email"
            name="email"
            placeholder="Email*"
            value={contact.email}
            onChange={(e) => handleInputChange(e, "contact")}
            required
            className="checkout-input"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Telefon*"
            value={contact.phone}
            onChange={(e) => handleInputChange(e, "contact")}
            required
            className="checkout-input"
          />
        </div>
        <div className="selected-delivery-method">
          <h2>Metodă de livrare:</h2>
          <p className={deliveryMethod ? "" : "red-text"}>
            {deliveryMethod
              ? ` ${
                  deliveryMethod === "curier"
                    ? "Livrare prin curier"
                    : "Ridicare personală"
                }`
              : "Vă rugăm selectați una din metodele de livrare de mai sus."}
          </p>
        </div>

        <div className="remarks">
          <h2>Mențiuni</h2>
          <p>
            Adăugați orice mențiuni aveți la comandă, inclusiv dacă plata va fi
            făcută de către o persoană cu un nume diferit de cel menționat
            anterior.
          </p>
          <textarea
            name="remarks"
            placeholder="Adăugați mentiuni aici"
            value={remarks}
            onChange={handleRemarksChange}
            rows="4" // Setează înălțimea câmpului
            className="remarks-textarea" // Poți adăuga un CSS pentru styling
          />
        </div>

        <div className="terms-conditions">
          <label className="red-text">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
            />
            Sunt de acord ca datele mele personale să fie utilizate pentru
            procesarea comenzii, pentru a susține experiența pe tot acest site
            web și în alte scopuri descrise în politicile din pagina{" "}
            <a href="/policy" target="_blank" rel="noopener noreferrer">
              termeni si condiții
            </a>
            .
          </label>
        </div>

        <div className="terms-conditions">
          <label className="red-text">
            <input
              type="checkbox"
              checked={termsGeneralAccepted}
              onChange={(e) => setTermsGeneralAccepted(e.target.checked)}
            />
            Am citit și sunt de acord cu{" "}
            <a href="/policy" target="_blank" rel="noopener noreferrer">
              termenii și condițiile site-ului web
            </a>
            .
          </label>
        </div>

        <div className="terms-conditions">
          <label className="red-text">
            <input
              type="checkbox"
              checked={paymentInfoAccepted}
              onChange={(e) => setPaymentInfoAccepted(e.target.checked)}
            />
            Am citit și înțeles informațiile cu privire la efectuarea plății.
          </label>
        </div>

        {/* Divider gros și totalul */}
        <hr className="thick-divider" />
        <div className="total-summary">
          <div className="total-price">
            <h2>Total: {calculateTotalPrice()} RON</h2>
          </div>
          <div className="submit-container">
            <button className="submit-button" onClick={handleSubmit}>
              Plasează Comanda
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyCart;
